import JobDetailsContainer from "../../../../Components/Miscellaneous/JobSearch/JobDetails/JobDetailsContainer";

const JobDetails = () => {
  return <JobDetailsContainer />;
};

export default JobDetails;
